import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';

import { PATH_AFTER_LOGIN } from '../config';

import {
  LoginPage,
  PageOne,
  PageNotFound,
  QuizListPage,
  QuizDetailPage,
  // QuizModifyPage,
  ModifyQuestionPage,
  QuestionDetailPage,
  QuestionListPage,
  ModifyRewardPage,
  RewardDetailPage,
  RewardListPage,
  ParticipantDetailPage,
  ParticipantEditPage,
  ParticipantListPage,
  CompetitionReportPage,
  QuestionsReportPage,
  UsersReportPage,
  AccountantPage,
  GiveawayListPage,
  NewQuizModifyPage,
  TransactionList,
  WithdrawRequest,
  ShopListPage,
  ShopModifyPage,
} from './elements';
import { PATH_DASHBOARD } from './paths';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },
    // Dashboard
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // <GuestGuard>
        //   <DashboardLayout />
        // </GuestGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <PageOne /> },
        {
          path: 'competition',
          children: [
            {
              element: <Navigate to="/dashboard/competition/list" replace />,
              index: true,
            },
            { path: 'list', element: <QuizListPage /> },
            { path: 'quiz/:id', element: <QuizDetailPage /> },
            { path: 'quiz/new', element: <NewQuizModifyPage isEdit={0} /> },
            {
              path: 'quiz/:id/edit',
              element: <NewQuizModifyPage isEdit={1} />,
            },
          ],
        },
        {
          path: 'bank',
          children: [
            {
              element: <Navigate to="/dashboard/bank/questions" replace />,
              index: true,
            },
            { path: 'questions', element: <QuestionListPage /> },
            { path: 'question/:id', element: <QuestionDetailPage /> },
            { path: 'question/new', element: <ModifyQuestionPage isEdit={0} /> },
            {
              path: 'question/:id/edit',
              element: <ModifyQuestionPage isEdit={1} />,
            },
          ],
        },
        {
          path: 'reward',
          children: [
            {
              element: <Navigate to="/dashboard/reward/list" replace />,
              index: true,
            },
            { path: 'list', element: <RewardListPage /> },
            { path: 'reward/:id', element: <RewardDetailPage /> },
            { path: 'reward/new', element: <ModifyRewardPage isEdit={0} /> },
            {
              path: 'reward/:id/edit',
              element: <ModifyRewardPage isEdit={1} />,
            },
          ],
        },
        {
          path: 'users',
          children: [
            {
              element: <Navigate to="/dashboard/users/participant/list" replace />,
              index: true,
            },
            { path: 'participant/list', element: <ParticipantListPage /> },
            { path: 'participant/:id', element: <ParticipantDetailPage /> },
            {
              path: 'participant/:id/edit',
              element: <ParticipantEditPage />,
            },
          ],
        },
        {
          path: 'report',
          children: [
            {
              element: <Navigate to="/dashboard/report/competition" replace />,
              index: true,
            },
            { path: 'competitions', element: <CompetitionReportPage /> },
            { path: 'questions', element: <QuestionsReportPage /> },
            {
              path: 'users',
              element: <UsersReportPage />,
            },
          ],
        },
        {
          path: 'accountant',
          children: [
            {
              element: <Navigate to="/dashboard/accountant/main" replace />,
              index: true,
            },
            { path: 'main', element: <AccountantPage /> },
            { path: 'transaction-list', element: <TransactionList /> },
            { path: 'withdraw-request', element: <WithdrawRequest /> },
          ],
        },
        {
          path: 'giveaways',
          children: [
            {
              element: <Navigate to="/dashboard/giveaways/list" replace />,
              index: true,
            },
            { path: 'list', element: <GiveawayListPage /> },
          ],
        },
        {
          path: 'shop',
          children: [
            {
              element: <Navigate to="/dashboard/shop/list" replace />,
              index: true,
            },
            { path: 'list', element: <ShopListPage /> },
            { path: 'modify', element: <ShopModifyPage /> },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <PageNotFound /> },
        { path: '*', element: <Navigate to={PATH_DASHBOARD.general.app} replace /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
